import React, { useContext } from 'react';
import { IndexContext } from '../../context'

const HowItWorks = ({ howItWorksSec, styles = {} }) => {
  const { isLogged } = useContext(IndexContext);

  return (
    <div className="index-how-works">
      <h2 className={`index-heading-blue ${styles.headingBlue} index-how-works-heading`}
          children={howItWorksSec.worksTitleH2}/>
      <p className="index-how-works-text" children={howItWorksSec.worksText}/>
      <small className="index-how-works-small" children={howItWorksSec.worksTextSmall}/>
      {!isLogged && (
        <a
          className={`btn-orange ${styles.btn}`}
          href="/authorization/registration/"
          children={howItWorksSec.worksButton}
        />
      )}
    </div>
  )
}

export default HowItWorks;
